import YAML from 'yaml';

// The default 80-column fold rewrites code on parse. Strings that can't be `|` blocks (whitespace-only last
// line, control characters) fall back to double quotes, which fold newly typed lines into the one above unless JSON.
const EDITOR_STRINGIFY_OPTIONS = { lineWidth: -1, doubleQuotedAsJSON: true };

export default function stringifyEditorYaml(value) {
  return YAML.stringify(value, EDITOR_STRINGIFY_OPTIONS);
}
